// reuse name for type checking in SelectList
export const SelectOptionDisplayName = 'SelectOption';
export const SelectOptionGroupDisplayName = 'SelectOptionGroup';
